import type { IDealGroup } from '@/Interfaces/Beeswax/DealGroup.interface';
import axios from 'axios';

const dealGroupsEndpoint = '/deals/groups';

export const fetchDealGroups = async () => {
  const response = await axios.get<IDealGroup[]>(dealGroupsEndpoint);
  return response.data;
};
